<template>
  <!-- Plein écran, hors AppLayout : l'assistant a son propre rail d'étapes. -->
  <div v-if="!isProgramsPendingRef">
    <a href="#main-content" class="skip-link" @click.prevent="skipToContent">
      {{ t('ui.layout.skipToContent') }}
    </a>
    <PlatformSetup />
    <AppHooks />
    <TermsModal />
  </div>
</template>

<script setup lang="ts">
import AppHooks from '@/(routes)/(protected)/(app)/app-hooks.vue'
import PlatformSetup from '@/features/admin/platform-setup/components/platform-setup.vue'
import TermsModal from '@/features/legal/components/terms-modal/terms-modal.vue'
import usePrograms from '@/features/programs/hooks/use-programs.hook'
import { useI18n } from '@/lib/i18n'

const { t } = useI18n()
const { isPendingRef: isProgramsPendingRef } = usePrograms()

function skipToContent() {
  document.getElementById('main-content')?.focus()
}
</script>

<style scoped>
.skip-link {
  position: absolute;
  left: -9999px;
  z-index: 999;
  padding: 0.5rem 1rem;
  background: var(--background);
  color: var(--foreground);
  border: 2px solid var(--foreground);
  border-radius: 0.25rem;
  font-size: 0.875rem;
  text-decoration: none;
}

.skip-link:focus {
  left: 0.5rem;
  top: 0.5rem;
}
</style>
